import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Logo } from "../components/AppShell";
import { adminLogin, adminLogin2fa, formatErr } from "../lib/api";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [step, setStep] = useState("password");
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [code, setCode] = useState("");
  const [challenge, setChallenge] = useState("");
  const [loading, setLoading] = useState(false);

  const submitPwd = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await adminLogin(email, pwd);
      if (res.requires_2fa) {
        setChallenge(res.challenge_token);
        setStep("2fa");
        toast.info("Introduce el código de tu app de autenticación");
      } else {
        localStorage.setItem("el_admin_token", res.access_token);
        toast.success("Bienvenido");
        navigate("/admin");
      }
    } catch (err) { toast.error(formatErr(err)); }
    finally { setLoading(false); }
  };

  const submit2fa = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await adminLogin2fa(challenge, code);
      localStorage.setItem("el_admin_token", res.access_token);
      toast.success("Bienvenido");
      navigate("/admin");
    } catch (err) { toast.error(formatErr(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="app-shell">
      <div className="app-frame flex flex-col">
        <header className="px-5 py-4 border-b border-slate-100">
          <Logo size={32} withWordmark />
        </header>
        <main className="flex-1 px-5 py-8 fade-in flex flex-col justify-center">
          {step === "password" && (
            <>
              <h1 className="text-3xl font-[Outfit] font-extrabold tracking-tight text-slate-900">Panel Admin</h1>
              <p className="text-sm text-slate-600 mt-1">Acceso solo para el equipo.</p>
              <form onSubmit={submitPwd} className="mt-6 space-y-4" data-testid="admin-login-form">
                <div className="space-y-1.5">
                  <Label className="text-sm">Email</Label>
                  <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                    placeholder="admin@ejemplo.com" data-testid="input-admin-email" required />
                </div>
                <div className="space-y-1.5">
                  <Label className="text-sm">Contraseña</Label>
                  <Input type="password" value={pwd} onChange={(e) => setPwd(e.target.value)}
                    placeholder="••••••••" data-testid="input-admin-password" required />
                </div>
                <Button type="submit" disabled={loading}
                  className="btn-primary h-12 rounded-xl w-full font-semibold"
                  data-testid="btn-admin-login">
                  {loading ? "Entrando..." : "Entrar"}
                </Button>
                <button type="button" onClick={() => navigate("/admin/forgot")}
                  className="block mx-auto text-sm text-slate-600 underline underline-offset-4"
                  data-testid="link-forgot">
                  ¿Olvidaste tu contraseña?
                </button>
              </form>
            </>
          )}

          {step === "2fa" && (
            <>
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-slate-50 border border-slate-200 w-fit">
                <ShieldCheck className="w-3.5 h-3.5 text-[var(--el-red)]" />
                <span className="text-xs font-semibold text-slate-700">Verificación 2FA</span>
              </div>
              <h1 className="text-3xl font-[Outfit] font-extrabold tracking-tight text-slate-900 mt-3">
                Código de seguridad
              </h1>
              <p className="text-sm text-slate-600 mt-1">
                Introduce el código de 6 dígitos de tu app o un código de recuperación.
              </p>
              <form onSubmit={submit2fa} className="mt-6 space-y-4" data-testid="admin-2fa-form">
                <Input value={code} autoFocus
                  onChange={(e) => setCode(e.target.value.toUpperCase())}
                  placeholder="000000"
                  className="h-14 text-center text-xl tracking-[0.4em] font-bold rounded-2xl"
                  data-testid="input-2fa-code" required />
                <Button type="submit" disabled={loading}
                  className="btn-primary h-12 rounded-xl w-full font-semibold"
                  data-testid="btn-2fa-submit">
                  {loading ? "Verificando..." : "Verificar"}
                </Button>
                <button type="button" onClick={() => { setStep("password"); setCode(""); }}
                  className="block mx-auto text-sm text-slate-500 underline underline-offset-4">
                  Volver
                </button>
              </form>
            </>
          )}
        </main>
      </div>
    </div>
  );
}
